// extracted by mini-css-extract-plugin
export default {"drop_down":"styles_drop_down__Yk-Yk","icon":"styles_icon__RPS60","block":"styles_block__+HW4o","images_market":"styles_images_market__cxKzh","navigate":"styles_navigate__2T1Px"};